import React from "react";
import { Box, Stack, TextField, Typography } from "@mui/material";

const SX_CAMPO = {
    "& .MuiOutlinedInput-root": {
        backgroundColor: "#fff",
    },
};

/**
 * Campos de la dirección donde se recoge la mercancía.
 *
 * Solo pinta: el estado, las validaciones y la decisión de si la dirección es del
 * cliente o suelta viven en RecogidaForm.
 *
 * @param {Object} valores - { nombreDireccion, direccion, codigoPostal, poblacion, provincia }
 * @param {Object} errores - Mensaje de error por campo, con las mismas claves
 * @param {Function} onCampoChange - (campo, valor) al escribir en cualquier campo
 * @param {string} aviso - Texto explicativo bajo el título (opcional)
 */
export default function SeccionDireccion({ valores, errores = {}, onCampoChange, aviso = null }) {
    return (
        <Box sx={{
            p: { xs: 1.5, sm: 2 },
            backgroundColor: "#fff",
            borderRadius: 1,
            border: "1px solid #dee2e6"
        }}>
            <Typography
                variant="body2"
                sx={{
                    fontWeight: 600,
                    mb: 1,
                    color: "#495057",
                }}
            >
                Datos de la dirección
            </Typography>

            {aviso && (
                <Typography
                    variant="caption"
                    sx={{
                        display: "block",
                        mb: 2,
                        color: "#6c757d",
                        fontStyle: "italic"
                    }}
                >
                    {aviso}
                </Typography>
            )}

            <Stack spacing={2}>
                {/* Nombre de contacto */}
                <TextField
                    label="Nombre de contacto *"
                    value={valores.nombreDireccion}
                    onChange={(e) => onCampoChange('nombreDireccion', e.target.value)}
                    error={Boolean(errores.nombreDireccion)}
                    helperText={errores.nombreDireccion}
                    fullWidth
                    placeholder="Ej: Juan Pérez, María García..."
                    sx={SX_CAMPO}
                />

                {/* Dirección */}
                <TextField
                    label="Dirección *"
                    value={valores.direccion}
                    onChange={(e) => onCampoChange('direccion', e.target.value)}
                    error={Boolean(errores.direccion)}
                    helperText={errores.direccion}
                    fullWidth
                    placeholder="Ej: Calle Principal 123"
                    sx={SX_CAMPO}
                />

                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                    {/* Código Postal */}
                    <TextField
                        label="Código Postal *"
                        value={valores.codigoPostal}
                        onChange={(e) => onCampoChange('codigoPostal', e.target.value)}
                        error={Boolean(errores.codigoPostal)}
                        helperText={errores.codigoPostal}
                        fullWidth
                        placeholder="Ej: 38001"
                        sx={SX_CAMPO}
                    />

                    {/* Población */}
                    <TextField
                        label="Población *"
                        value={valores.poblacion}
                        onChange={(e) => onCampoChange('poblacion', e.target.value)}
                        error={Boolean(errores.poblacion)}
                        helperText={errores.poblacion}
                        fullWidth
                        placeholder="Ej: Santa Cruz de Tenerife"
                        sx={SX_CAMPO}
                    />
                </Stack>

                {/* Provincia */}
                <TextField
                    label="Provincia *"
                    value={valores.provincia}
                    onChange={(e) => onCampoChange('provincia', e.target.value)}
                    error={Boolean(errores.provincia)}
                    helperText={errores.provincia}
                    fullWidth
                    placeholder="Ej: Santa Cruz de Tenerife"
                    sx={SX_CAMPO}
                />
            </Stack>
        </Box>
    );
}
